import { render, staticRenderFns } from "./LoginProcess.vue?vue&type=template&id=2427a2b5&scoped=true"
import script from "./LoginProcess.vue?vue&type=script&lang=ts"
export * from "./LoginProcess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427a2b5",
  null
  
)

export default component.exports